<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de coletas agendadas">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>
            <rkm-layout-content v-if="loaded">
                <Form
                    :data="{ initials, form, model, additionals }"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/exame-laboratorial/coleta-agendada/Form'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            coleta: this.getConectaSusRepository('exameLaboratorial.coletaAgendada')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.coleta.list()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)
                    
                    this.initials.model = Object.freeze({
                        ...this.clone(data.model),
                        unidadeId: this.unidade,
                        atendimentoUnidadeId: this.atendimentoUnidade,
                        coletaId: this.coleta,
                        atendimentoColetaId: this.atendimentoColeta,
                    })

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            
            
        },
        handleExit() {

            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'dashboard' })
        }
    },
    mixins: [repository, error, object, data],
    props: {
        unidade: Number,
        atendimentoUnidade: Number,
        coleta: Number,
        atendimentoColeta: Number
    }
}
</script>